var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", { staticClass: "report-item" }, [
    _vm.option
      ? _c("div", [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                  },
                },
                [
                  _vm.option.title
                    ? _c(
                        "div",
                        [
                          _vm._v(" " + _vm._s(_vm.option.title) + " "),
                          _vm.option.tooltip
                            ? [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.option.tooltip
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "icon-a-01wenhao iconfont-el icon",
                                    }),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._t("buttons"),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticStyle: { flex: "1", "text-align": "end" } },
                    [
                      _vm.option.btns
                        ? _c(
                            "div",
                            { staticClass: "btns-box" },
                            [
                              _vm._l(_vm.option.btns, function (item, index) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      key: index,
                                      attrs: {
                                        disabled: !item.tip,
                                        effect: "dark",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: item.tip,
                                              expression: "item.tip",
                                            },
                                          ],
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [_c("div", [_vm._v(_vm._s(item.tip))])]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "btn",
                                          attrs: {
                                            type: "text",
                                            icon: item.loading
                                              ? "el-icon-loading"
                                              : "",
                                            title: item.tip,
                                          },
                                          on: {
                                            click: function ($event) {
                                              !item.loading &&
                                                _vm.onBtnClick(item)
                                            },
                                          },
                                        },
                                        [
                                          !item.loading
                                            ? _c("i", {
                                                class: ["iconfont", item.icon],
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.option.filterTitle
                        ? _c("span", [_vm._v(_vm._s(_vm.option.filterTitle))])
                        : _vm._e(),
                      _vm.option.filterParam
                        ? _c(
                            "el-select",
                            {
                              staticClass: "filter-select",
                              attrs: {
                                placeholder: _vm.option.filterPlaceholder
                                  ? _vm.option.filterPlaceholder
                                  : "请选择",
                              },
                              on: { change: _vm.handleFilter },
                              model: {
                                value: _vm.option.filter,
                                callback: function ($$v) {
                                  _vm.$set(_vm.option, "filter", $$v)
                                },
                                expression: "option.filter",
                              },
                            },
                            _vm._l(_vm.option.filterOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm.option.doubleShaft
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.handleFilter },
                                  model: {
                                    value: _vm.option.doubleShaft,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.option, "doubleShaft", $$v)
                                    },
                                    expression: "option.doubleShaft",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("单轴"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("双轴"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.option.timeSelect
                    ? _c("el-date-picker", {
                        staticClass: "filter-select",
                        staticStyle: { width: "250px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": _vm.$t(
                            "system::time::text::include"
                          ),
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "picker-options": _vm.pickerOptions,
                        },
                        on: { change: _vm.handleFilter },
                        model: {
                          value: _vm.timeRange,
                          callback: function ($$v) {
                            _vm.timeRange = $$v
                          },
                          expression: "timeRange",
                        },
                      })
                    : _vm._e(),
                  _vm._t("customerFilter"),
                ],
                2
              ),
              _vm._t("search", null, { option: _vm.option }),
              _vm.option.tip
                ? _c("div", { staticClass: "tip" }, [
                    _vm._v(_vm._s(_vm.option.tip)),
                  ])
                : _vm._e(),
              _vm._t("other", null, { option: _vm.option }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "report-wrap" },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.config &&
                      _vm.config.chart &&
                      _vm.config.chart.series.length &&
                      _vm.config.chart.series[0].data &&
                      _vm.config.chart.series[0].data.length,
                    expression:
                      "\n          config &&\n          config.chart &&\n          config.chart.series.length &&\n          config.chart.series[0].data &&\n          config.chart.series[0].data.length\n        ",
                  },
                ],
                ref: _vm.option.ref,
                style: "flex:1;height:" + _vm.option.height + ";",
              }),
              _c("defaultData", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.config &&
                      _vm.config.chart &&
                      (!_vm.config.chart.series.length ||
                        !_vm.config.chart.series[0].data.length),
                    expression:
                      "config && config.chart && (!config.chart.series.length || !config.chart.series[0].data.length)",
                  },
                ],
                staticStyle: { flex: "1" },
                attrs: { custom: { height: _vm.option.height } },
              }),
              _vm._t("reportInfo"),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }